import { Injectable, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class InitialService {
  private script!: HTMLScriptElement;
  private static promise: Promise<void>;

  constructor(@Inject(PLATFORM_ID) private platformId: object) {}

  async setUpGoogleScript(): Promise<void> {
    if (isPlatformBrowser(this.platformId)) {
      setTimeout(() => {
        // Set Google API key dynamically
        const head = document.getElementsByTagName('body')[0];

        if (!document.getElementById('testScriptName')) {
          this.script = document.createElement('script');
          this.script.type = 'text/javascript';
          this.script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleKey}&libraries=places,drawing,geometry,visualization&language=en`;
          this.script.id = 'newTestScriptName';
          this.script.async = true;
          head.appendChild(this.script);
        }
      }, 100);
    }
  }

  public load(): Promise<void> {
    if (!InitialService.promise && isPlatformBrowser(this.platformId)) {
      InitialService.promise = new Promise<void>((resolve) => {
        const script = document.createElement('script');
        script.src = `https://maps.googleapis.com/maps/api/js?key=${environment.googleKey}&libraries=places,drawing,geometry,visualization&language=en`;
        script.onload = (): any => resolve();
        document.head.appendChild(script);
      });
    }
    return InitialService.promise || Promise.resolve();
  }
}
